import axios from 'axios'
import Constants from '../constants'

export default {
  getTranslation: () => {
    return new Promise((resolve) => {
      axios.get('translation', { params: { id: Constants.API_ID } })
        .then(payload => {
          resolve(payload.data)
        })
    })
  }
}
